import React from 'react';

import { BaseConfig } from '@eika-infrastruktur/config-provider';
import { loadContainers } from '@eika-infrastruktur/render';

import IbanCalculator from './IbanCalculator';
import { defaultConfig } from './config';

const renderApp = (MyApp: React.ComponentType, namespace: string, appDefaultConfig: BaseConfig): void => {
    loadContainers(
        namespace,
        () => (
            <div className="no-eika-engine">
                <MyApp />
            </div>
        ),
        appDefaultConfig,
    );
};

renderApp(IbanCalculator, 'no.eika.engine.ibancalculator', defaultConfig);
